import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';

import {ClearSettingsRow} from '../components/ClearSettingsRow';
import {useMediaSettingsDrawerContext} from './MediaSettingsDrawerContextProvider';
import {MediaSettingsSection, SettingsLevel} from './types';

export const MediaSettingsDrawerSection = ({
  title,
  settings,
}: MediaSettingsSection) => {
  const [isOpen, setIsOpen] = useState(true);
  const {config, numberOfOverridesBelow, clearOverridesBelow} =
    useMediaSettingsDrawerContext();
  return (
    <div className="flex flex-col pt-16 first:pt-0">
      <div className="flex items-center">
        <Button
          data-test={`media-settings-drawer-section-toggle-${title}`}
          icon={isOpen ? 'chevron-down' : 'chevron-next'}
          onClick={() => setIsOpen(!isOpen)}
          variant="ghost"
          size="small"
        />
        <div className="ml-8 text-xl font-semibold">{title}</div>
      </div>
      {isOpen && (
        <div
          className="pl-[32px] pt-8"
          data-test={`media-settings-drawer-section-${title}`}>
          {settings.map(
            (
              {component: SettingComponent, getComponentKey, configKey},
              index
            ) => (
              <div
                key={`${title}-${index}-${getComponentKey?.(config) ?? ''}`}
                className="flex flex-col gap-8 pt-16 first:pt-0">
                <SettingComponent />
                {config[configKey] != null &&
                  Object.keys(numberOfOverridesBelow ?? {}).map(level => {
                    const levelKey = level as SettingsLevel; // We know that the keys are all SettingsLevel values
                    if (
                      numberOfOverridesBelow?.[levelKey]?.[configKey] ===
                      undefined
                    ) {
                      return null;
                    }
                    return (
                      <ClearSettingsRow
                        key={levelKey}
                        settingLevel={levelKey}
                        count={numberOfOverridesBelow?.[levelKey]?.[configKey]}
                        clearSetting={() =>
                          clearOverridesBelow?.[levelKey]?.(configKey)
                        }
                        settingKey={configKey}
                      />
                    );
                  })}
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};
